"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleBookingEvents = exports.getInsuranceProducts = exports.getTransportationProducts = exports.getCruiseProduct = void 0;
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var DATE_FORMAT = 'DD.MM.YYYY';
var surchargeIDToName = {
    EBP: 'Frühbucher-Plus',
    EB: 'Frühbucher',
};
var insuranceIDToName = {
    '0': 'Reise-Rücktritt',
    '1': 'Reise-Rücktritt',
    '2': 'Reise-Rücktritt',
    '4': 'AIDA-Komplettschutz',
    '5': 'AIDA-Komplettschutz',
    '6': 'AIDA-Komplettschutz',
    '7': 'AIDA-Komplettschutz',
    '8': 'AIDA-Komplettschutz',
    '9': 'AIDA-Komplettschutz',
};
function getPremiumCabinDetail(cabin) {
    var selectionConfig = (0, lodash_1.get)(cabin, 'cabins.selectionCategoryConfigurations', false);
    if (selectionConfig) {
        var result = (0, lodash_1.filter)(selectionConfig, function (item) {
            return item.cabin !== null && item.subCatgory !== null;
        });
        return result[0];
    }
}
function getCabinCategory(cabin) {
    var cc = (0, lodash_1.get)(cabin, 'cabins.cabinCategories.0', 'n/a');
    if (cc === undefined) {
        return undefined;
    }
    var mainCabinCategoryID = (0, lodash_1.defaultTo)((0, lodash_1.get)(cabin, 'cabins.cabinCategory'), cc.mainCode);
    var mainCabinCategoryIndex = (0, lodash_1.findIndex)((0, lodash_1.get)(cabin, 'cabins.cabinCategories', []), ['mainCode', mainCabinCategoryID]);
    if (mainCabinCategoryIndex === -1) {
        return undefined;
    }
    var mainCabinCategory = (0, lodash_1.get)(cabin, "cabins.cabinCategories.".concat(mainCabinCategoryIndex));
    if ((0, lodash_1.isNil)(mainCabinCategory)) {
        return undefined;
    }
    var activeAdditionalCategory = (0, lodash_1.get)(cabin, 'cabins.activeAdditionalCategory', 'NONE');
    if (activeAdditionalCategory === 'PREMIUM' ||
        activeAdditionalCategory === 'PREMIUMAI') {
        var selectionConfig = (0, lodash_1.get)(cabin, "cabins.selectionCategoryConfigurations.".concat(mainCabinCategoryIndex));
        if ((0, lodash_1.isNil)(selectionConfig) || (0, lodash_1.isNil)(selectionConfig.subCategory)) {
            var c = (0, lodash_1.get)(cabin, "cabins.cabins.".concat(mainCabinCategoryIndex));
            if ((0, lodash_1.isNil)(c)) {
                return mainCabinCategory;
            }
            var selectionCategoryConfigurations = (0, lodash_1.get)(cabin, 'cabins.selectionCategoryConfigurations', []);
            selectionConfig = (0, lodash_1.find)(selectionCategoryConfigurations, [
                'subCategory',
                c.category,
            ]);
            if ((0, lodash_1.isNil)(selectionConfig)) {
                return undefined;
            }
        }
        var mainCabinCategories = activeAdditionalCategory === 'PREMIUMAI'
            ? mainCabinCategory.premiumAICategories
            : mainCabinCategory.premiumCategories;
        return (0, lodash_1.find)(mainCabinCategories, ['code', selectionConfig.subCategory]);
    }
    return mainCabinCategory;
}
function getCruiseProduct(state, cabinName) {
    var cabin = (0, lodash_1.get)(state, "booking.".concat(cabinName), {
        persons: {
            adults: 0,
            juveniles: 0,
            children: 0,
        },
    });
    var adults = (0, lodash_1.get)(cabin, 'persons.adults', 0);
    var juveniles = (0, lodash_1.get)(cabin, 'persons.juveniles', 0);
    var children = (0, lodash_1.get)(cabin, 'persons.children', 0);
    var shipName = (0, lodash_1.get)(state, 'booking.general.cruise.shipName', '01.01.1970');
    var startDate = (0, lodash_1.get)(state, 'booking.general.cruise.departure', '01.01.1970');
    var endDate = (0, lodash_1.get)(state, 'booking.general.cruise.arrival', '01.01.1970');
    var cabinCategory = (0, lodash_1.defaultTo)(getCabinCategory(cabin), {
        name: '',
        price: 0,
        pricingsPerPax: [],
        surcharges: [],
        amenities: [],
        premiumAvailable: false,
        premiumAIAvailable: false,
        cheapestPremiumPrice: 0,
        cheapestPremiumAIPrice: 0,
    });
    var premiumCabinDetail = getPremiumCabinDetail(cabin);
    var daysToCruise = (0, moment_1.utc)(startDate, DATE_FORMAT).diff((0, moment_1.utc)(), 'days');
    var price = (0, lodash_1.get)(cabinCategory, 'price', 0);
    price = price === 0 ? (0, lodash_1.sum)(cabinCategory.pricingsPerPax) : price;
    var additionalCategory = (0, lodash_1.get)(cabin, 'cabins.activeAdditionalCategory', 'NONE');
    var priceModel = (0, lodash_1.get)(state, 'booking.general.cruise.priceModel', '');
    if (priceModel === 'IND') {
        priceModel = 'PREMIUM';
    }
    if ((cabinCategory.premiumAvailable && priceModel === 'PREMIUM') ||
        (cabinCategory.premiumAIAvailable && priceModel === 'PREMIUMAI')) {
        price =
            priceModel === 'PREMIUM'
                ? cabinCategory.cheapestPremiumPrice || 0
                : cabinCategory.cheapestPremiumAIPrice || 0;
    }
    var surchargesAmenities = (0, lodash_1.uniq)(__spreadArray(__spreadArray([], (0, lodash_1.map)(cabinCategory.surcharges, function (s) {
        if ((0, lodash_1.isNil)(s.type)) {
            return;
        }
        return (0, lodash_1.get)(surchargeIDToName, s.type, s.type);
    }), true), (0, lodash_1.map)(cabinCategory.amenities, 'id'), true));
    var cruiseID = (0, lodash_1.get)(state, 'booking.general.cruise.id', '');
    var cruiseName = (0, lodash_1.get)(state, 'booking.general.cruise.name', '');
    var duration = (0, lodash_1.get)(state, 'booking.general.cruise.duration', '');
    var cabinCategoryName = (0, lodash_1.get)(cabinCategory, 'name', '');
    return {
        id: cruiseID,
        name: "".concat(cruiseName, " ").concat(duration, " Tage mit ").concat(shipName, ", ").concat(startDate, " bis ").concat(endDate),
        brand: shipName,
        category: priceModel,
        variant: cabinCategoryName,
        quantity: 1,
        price: price.toFixed(2),
        dimension31: cruiseID,
        dimension32: 'cruise',
        dimension33: surchargesAmenities.join('/'),
        dimension34: (0, lodash_1.get)(state, 'booking.general.cruise.departureStationName', ''),
        dimension35: (0, lodash_1.get)(state, 'booking.general.cruise.arrivalStationName', ''),
        dimension36: (0, lodash_1.get)(state, 'booking.general.cruise.name', ''),
        dimension37: (0, lodash_1.get)(state, 'booking.general.cruise.region', ''),
        dimension38: "A".concat(adults, "_J").concat(juveniles, "_C").concat(children),
        dimension39: (0, lodash_1.get)(state, 'booking.general.cruise.duration', '').toString(),
        dimension40: (0, moment_1.utc)(startDate, DATE_FORMAT).format('YYYY-MM-DD'),
        dimension41: (0, moment_1.utc)(endDate, DATE_FORMAT).format('YYYY-MM-DD'),
        dimension45: daysToCruise.toString(),
        dimension73: (0, lodash_1.get)(premiumCabinDetail, 'subCategory', null),
        dimension74: (0, lodash_1.get)(premiumCabinDetail, 'cabin', null),
    };
}
exports.getCruiseProduct = getCruiseProduct;
function getTransportationProducts(state, cabinName) {
    var cabin = state.booking[cabinName];
    if (cabin === undefined) {
        return [];
    }
    var cruiseID = (0, lodash_1.get)(state, 'booking.general.cruise.id', '');
    var products = [];
    var transportationType = (0, lodash_1.get)(cabin, 'transport.type', 'n/a');
    switch (transportationType) {
        case 'flight':
            if ((0, lodash_1.get)(cabin, 'transportAir.withOutNoFlight', false) === false &&
                (0, lodash_1.get)(cabin, 'transportAir.withRetNoFlight', false) === false &&
                (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.activated', false) &&
                (0, lodash_1.get)(cabin, 'transportAir.returningSelection.activated', false) &&
                (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.selected', false) ===
                    (0, lodash_1.get)(cabin, 'transportAir.returningSelection.selected', false)) {
                var airportID = (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.selected');
                var classID = (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.flightClass');
                var twoWay_1 = (0, lodash_1.get)(cabin, 'transportAir.flights.twoWay', {});
                var flight = (0, lodash_1.get)(twoWay_1, "".concat(classID, ".").concat(airportID, "[0]"), {});
                products.push({
                    name: (0, lodash_1.get)(flight, 'outgoingFlight.segments[0].departureAirportName'),
                    brand: (0, lodash_1.get)(flight, 'outgoingFlight.segments[0].carrier.name'),
                    category: 'Flug - Anreise',
                    variant: (0, lodash_1.get)(flight, 'className'),
                    quantity: 1,
                    price: (0, lodash_1.get)(flight, 'outgoingFlight.price', 0.0).toFixed(2),
                    dimension31: cruiseID,
                    dimension32: 'transfer',
                });
                products.push({
                    name: (0, lodash_1.get)(flight, 'returnFlight.segments[0].departureAirportName'),
                    brand: (0, lodash_1.get)(flight, 'returnFlight.segments[0].carrier.name'),
                    category: 'Flug - Abreise',
                    variant: (0, lodash_1.get)(flight, 'className'),
                    quantity: 1,
                    price: (0, lodash_1.get)(flight, 'returnFlight.price', 0.0).toFixed(2),
                    dimension31: cruiseID,
                    dimension32: 'transfer',
                });
                break;
            }
            if ((0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.activated', false)) {
                var airportID = (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.selected');
                var classID = (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.flightClass');
                var flight = (0, lodash_1.get)(cabin, "transportAir.flights.outgoing.".concat(classID, ".").concat(airportID, "[0]"), (0, lodash_1.get)(cabin, "transportAir.flights.twoWay.".concat(classID, ".").concat(airportID, "[0]"), {}));
                if (flight.outgoingFlight) {
                    products.push({
                        name: (0, lodash_1.get)(flight, 'outgoingFlight.segments[0].departureAirportName'),
                        brand: (0, lodash_1.get)(flight, 'outgoingFlight.segments[0].carrier.name'),
                        category: 'Flug - Anreise',
                        variant: (0, lodash_1.get)(flight, 'className'),
                        quantity: 1,
                        price: (0, lodash_1.get)(flight, 'outgoingFlight.price', 0.0).toFixed(2),
                        dimension31: cruiseID,
                        dimension32: 'transfer',
                    });
                }
            }
            if ((0, lodash_1.get)(cabin, 'transportAir.returningSelection.activated', false)) {
                var airportID = (0, lodash_1.get)(cabin, 'transportAir.returningSelection.selected');
                var classID = (0, lodash_1.defaultTo)((0, lodash_1.get)(cabin, 'transportAir.returningSelection.flightClass'), (0, lodash_1.get)(cabin, 'transportAir.outgoingSelection.flightClass'));
                var flight = (0, lodash_1.get)(cabin, "transportAir.flights.returning.".concat(classID, ".").concat(airportID, "[0]"), (0, lodash_1.get)(cabin, "transportAir.flights.twoWay.".concat(classID, ".").concat(airportID, "[0]"), {}));
                if (flight.returnFlight) {
                    products.push({
                        name: (0, lodash_1.get)(flight, 'returnFlight.segments[0].departureAirportName'),
                        brand: (0, lodash_1.get)(flight, 'returnFlight.segments[0].carrier.name'),
                        category: 'Flug - Abreise',
                        variant: (0, lodash_1.get)(flight, 'className'),
                        quantity: 1,
                        price: (0, lodash_1.get)(flight, 'returnFlight.price', 0.0).toFixed(2),
                        dimension31: cruiseID,
                        dimension32: 'transfer',
                    });
                }
            }
            break;
        case 'rail':
            var hasDeparture = (0, lodash_1.get)(cabin, 'transportRail.departure', false);
            var hasArrival = (0, lodash_1.get)(cabin, 'transportRail.arrival', false);
            var twoWay = hasDeparture && hasArrival;
            var totalPrice = (0, lodash_1.get)(cabin, 'transportRail.totalPrice', 0.0);
            var price = twoWay ? totalPrice / 2 : totalPrice;
            if (hasDeparture) {
                products.push({
                    name: (0, lodash_1.get)(cabin, 'transportRail.departureConfig.location', ''),
                    brand: 'Deutsche Barhn',
                    category: 'Bahn - Hinreise',
                    variant: (0, lodash_1.get)(cabin, 'transportRail.departureConfig.category', ''),
                    quantity: 1,
                    price: price.toFixed(2),
                    dimension31: cruiseID,
                    dimension32: 'transfer',
                });
            }
            if (hasArrival) {
                products.push({
                    name: (0, lodash_1.get)(cabin, 'transportRail.arrivalConfig.location', ''),
                    brand: 'Deutsche Barhn',
                    category: 'Bahn - Rückreise',
                    variant: (0, lodash_1.get)(cabin, 'transportRail.arrivalConfig.category'),
                    quantity: 1,
                    price: price.toFixed(2),
                    dimension31: cruiseID,
                    dimension32: 'transfer',
                });
            }
            break;
        default:
            products.push({
                name: 'Eigene An-und Abreise',
                category: 'individuell',
                quantity: 1,
                price: '0.00',
                dimension31: cruiseID,
                dimension32: 'transfer',
            });
    }
    return products;
}
exports.getTransportationProducts = getTransportationProducts;
function getInsuranceProducts(state, cabinName) {
    var cabin = state.booking[cabinName];
    if (cabin === undefined) {
        return [];
    }
    var insuranceID = (0, lodash_1.get)(cabin, 'insurance.selected', 'n/a');
    var insuranceList = (0, lodash_1.get)(cabin, 'insurance.list', []);
    var insurance = (0, lodash_1.find)(insuranceList, ['code', insuranceID]);
    if (insurance) {
        return [
            {
                brand: 'AIDA Reiseschutz',
                category: 'Reiseschutz',
                name: insuranceIDToName[insuranceID],
                price: (0, lodash_1.get)(insurance, 'price', 0.0).toFixed(2),
                quantity: 1,
                dimension31: (0, lodash_1.get)(state, 'booking.general.cruise.id', ''),
                dimension32: 'insurance',
            },
        ];
    }
    return [
        {
            brand: 'AIDA Reiseschutz',
            category: 'Reiseschutz',
            name: 'keine',
            price: '0.00',
            quantity: 1,
            dimension31: (0, lodash_1.get)(state, 'booking.general.cruise.id', ''),
            dimension32: 'insurance',
        },
    ];
}
exports.getInsuranceProducts = getInsuranceProducts;
function getCabinProducts(state, cabinName) {
    var cabin = state.booking[cabinName];
    var adults = (0, lodash_1.get)(cabin, 'persons.adults', 0);
    var juveniles = (0, lodash_1.get)(cabin, 'persons.juveniles', 0);
    var children = (0, lodash_1.get)(cabin, 'persons.children', 0);
    var guests = adults + juveniles + children;
    var cruise = getCruiseProduct(state, cabinName);
    cruise.metric1 = guests.toString();
    cruise.metric2 = adults.toString();
    cruise.metric3 = juveniles.toString();
    cruise.metric4 = children.toString();
    cruise.metric5 = '1';
    return __spreadArray(__spreadArray([
        cruise
    ], getTransportationProducts(state, cabinName), true), getInsuranceProducts(state, cabinName), true);
}
var handleBookingEvents = function (mutation, state) {
    var cabinNames = (0, lodash_1.get)(state, 'booking.basket', []);
    var cabins = (0, lodash_1.map)(cabinNames, function (cabinName) { return state.booking[cabinName]; });
    var buyer = {
        birthday: { value: '01.01.1960' },
    };
    for (var _i = 0, cabins_1 = cabins; _i < cabins_1.length; _i++) {
        var cabin = cabins_1[_i];
        var pax = (0, lodash_1.find)(cabin.pax.paxe, ['isBuyer', true]);
        if (pax !== undefined) {
            buyer = pax;
            break;
        }
    }
    var bookingID = (0, lodash_1.get)(state, 'booking.general.booking.number', '');
    var fullPrice = (0, lodash_1.get)(state, 'booking.checkout.price.fullPrice', '');
    var shipName = (0, lodash_1.get)(state, 'booking.general.cruise.shipName', '');
    var agencyId = (0, lodash_1.get)(state, 'booking.affiliate.agencyId', '');
    var priceModel = (0, lodash_1.get)(state, 'booking.general.cruise.priceModel', '');
    var amenities = (0, lodash_1.uniq)((0, lodash_1.flatten)((0, lodash_1.map)(cabinNames, function (cabinName) {
        var cabinCategory = getCabinCategory(state.booking[cabinName]);
        if (cabinCategory === undefined) {
            return [];
        }
        return (0, lodash_1.map)(cabinCategory.amenities, function (a) {
            return a.type;
        });
    })));
    var cabinProducts = (0, lodash_1.map)(cabinNames, function (name) { return getCabinProducts(state, name); });
    var products = (0, lodash_1.flatten)(cabinProducts);
    var cruiseProducts = (0, lodash_1.filter)(products, function (p) {
        return p.id !== undefined;
    });
    var cruiseRev = (0, lodash_1.sumBy)(cruiseProducts, function (cp) {
        return parseFloat(cp.price);
    });
    var cabinType = (0, lodash_1.map)(cabinNames, function (name) {
        var cabin = state.booking[name];
        var category = getCabinCategory(cabin);
        return (0, lodash_1.defaultTo)(category, { name: '' }).name;
    });
    var event = {
        event: 'EECpurchase',
        ecommerce: {
            currencyCode: 'EUR',
            dimension67: agencyId,
            purchase: {
                actionField: {
                    id: bookingID,
                    revenue: fullPrice.toFixed(2),
                    coupon: amenities.join('/'),
                },
                products: products,
            },
            cruiseTransactionId: bookingID,
            leadPax: (0, moment_1.utc)(buyer.birthday.value, DATE_FORMAT)
                .get('years')
                .toString(),
            ship: shipName,
            priceModel: priceModel,
            cabinType: cabinType.join('/'),
            cruiseRev: cruiseRev.toFixed(2),
        },
    };
    return [event];
};
exports.handleBookingEvents = handleBookingEvents;
//# sourceMappingURL=booking_events.js.map